// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IMobileSiteGetRecommendationsRequest,
  TMobileSiteGetRecommendationsModel,
  IMappers,
  TMobileSiteGetRecommendationsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetRecommendationsResponseV2 } from '../../../entities/recommendations/GetRecommendationsResponseV2';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createMobileSiteGetRecommendationsModel(
  parameters: IMobileSiteGetRecommendationsRequest,
): TMobileSiteGetRecommendationsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'feed-page',
    pathApi: '/v2/mobile-site/get-recommendations/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IMobileSiteGetRecommendationsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IMobileSiteGetRecommendationsRequest;
}

export async function fetchMobileSiteGetRecommendations<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IMobileSiteGetRecommendationsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TMobileSiteGetRecommendationsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createMobileSiteGetRecommendationsModel(parameters),
    config,
  )) as FetchResponse<TMobileSiteGetRecommendationsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRecommendationsResponseV2, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TMobileSiteGetRecommendationsResponse>;
}
